import React from 'react'
import {
  ListView,
  PullToRefresh,
  ActivityIndicator,
  Toast,
  List,
  Result
} from 'antd-mobile'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { commonBillListApi } from '@/api/payment'
import { setHeader } from '@/util/set-header'
import * as util from '@/util/util'
import './complex-list.less'
const APullToRefresh: any = PullToRefresh
const Item = List.Item
const Footer = ({ isLoading, isHasMore,dataSource }: any) => {
  if (!isHasMore) {
    if (dataSource._cachedRowCount > 0) {
      return <div className="text-center">没有更多啦</div>
    } else {
      return (
        <Result
          img={<img src="/public/assets/img/error.png" alt="" />}
          message={<div>您目前暂无缴费记录哦</div>}
        />
      )
    }
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}
function MyBody(props:any) {
    const {info,dataSource,goPay}=props
    return (
      <div className="am-list-body my-body">
         {dataSource._cachedRowCount > 0&&  <div className="complex-list-info">
        <p className="font-1">{info.is_qianfei?`-${util.toDecimal2(info.qianfei)}`:util.toDecimal2(info.balance)}</p>
        <div className="font-6" onClick={()=>goPay()}>充值</div>
      </div>}
        {props.children}
      </div>
    );
  }
const mapStateToProps = (state: any) => {
  return {
    payment: state.payment,
  }
}
@(connect(mapStateToProps) as any)
@(withRouter as any)
class ComplexList extends React.Component<any, any> {
  lv: any
  dataBlobs: any = {}
  //时间分类header
  sectionIDs: any = []
  rowIDs: any = []
  checkin_id: string = ''
  //用于下一页数据请求
  max_time: string = '0'
  subject_id:string=''
  isHasMore = true
  pageIndex = 0
  itemKeyValue: any = {
    '13001': { img:'bed-icon.png',url:"roomFeeList.json",color:'#15B6B1'}, //房费
    '13004':{ img:'cold_water_fee-icon.png',url:"coldWaterFeeList.json",color:'#019FE6'} , //冷水费
    '13005': { img:'hot_water_fee-icon.png',url:"hotWaterFeeList.json",color:'#4489CA'}, //热水费

  }
  constructor(props: any) {
    super(props)
    const getSectionData = (dataBlob: any, sectionID: any) =>
      dataBlob[sectionID]
    const getRowData = (dataBlob: any, sectionID: any, rowID: any) =>
      dataBlob[rowID]

    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1: any, row2: any) => row1 !== row2,
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
    })
    //subject_id
    this.subject_id=this.props.location.state.subject_id
    this.state = {
      dataSource,
      isLoading: true,
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    //绑定this ios低版本不兼容箭头函数
    this.genData = this.genData.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.onEndReached = this.onEndReached.bind(this)
    this.navDetail = this.navDetail.bind(this)
    this.goPay = this.goPay.bind(this)
  }
  UNSAFE_componentWillMount() {
    const title=this.props.location.state.subject_name+'余额'
    setHeader({ title,className: 'payment-record-nav', })
  }
  //分页请求
  async genData(checkin_id: string, max_time = '0') {
    const {subject_id}=this.props.location.state
    const url=`/base/checkin/${this.itemKeyValue[subject_id].url}`
    const { data } = await commonBillListApi(url,checkin_id, max_time)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    const list = data.data
    list.forEach((item: any) => {
      if (this.sectionIDs.indexOf(item.month) === -1) {
        this.sectionIDs.push(item.month)
      }
    })
    this.sectionIDs.forEach((sectionName: any, ii: any) => {
      this.dataBlobs[sectionName] = sectionName

      if (this.rowIDs[ii]) {
        this.rowIDs[ii] = [...this.rowIDs[ii]]
      } else {
        this.rowIDs[ii] = []
      }
      for (let jj = 0; jj < list.length; jj++) {
        const rowitem = list[jj]
        if (sectionName === rowitem.month) {
          this.rowIDs[ii].push(`${ii}${10 * this.pageIndex + jj}`)
          this.dataBlobs[`${ii}${10 * this.pageIndex + jj}`] = rowitem
        }
      }
    })
    this.sectionIDs = [...this.sectionIDs]
    this.rowIDs = [...this.rowIDs]
    this.max_time = data.max_time
    this.isHasMore = !data.is_end
    this.setState({
      dataSource: this.state.dataSource.cloneWithRowsAndSections(
        this.dataBlobs,
        this.sectionIDs,
        this.rowIDs,
      ),
      isLoading: false,
    })
  }
  async componentDidMount() {
    const hei =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.lv) as any).getBoundingClientRect().top

    this.setState({
      height: hei,
    })
    const { payment } = this.props
    if (payment.checkin_id) {
      this.setState({ isLoading: true })
      await this.genData(payment.checkin_id, '0')
      this.setState({ isLoading: false })
    }
  }

  async componentWillReceiveProps(nextProps: any) {
    const { payment } = this.props
    const nextInfo = nextProps.payment
    this.checkin_id = nextInfo.checkin_id
    if (payment.checkin_id !== nextInfo.checkin_id) {
      //获取待付款列表
      this.setState({ isLoading: true })
      await this.genData(this.checkin_id, '0')
      this.setState({ isLoading: false })
    }
  }
  //下拉刷新
  async onRefresh() {
    if (this.state.isLoading) {
      return
    }
    this.max_time = '0'
    this.sectionIDs = []
    this.rowIDs = []
    this.dataBlobs = {}
    this.setState({ isRefreshing: true, isLoading: true })
    await this.genData(this.checkin_id, this.max_time)
    this.setState({
      isRefreshing: false,
      isLoading: false,
    })
  }
  //上拉加载更多
  async onEndReached(event: any) {
    if (this.state.isLoading || !this.isHasMore) {
      return
    }
    this.pageIndex++
    this.setState({ isLoading: true })
    await this.genData(this.checkin_id, this.max_time)
    this.setState({ isLoading: false })
  }
  //查看缴费详情
  navDetail(item: any) {
    this.props.history.push({
      pathname: '/payment/bill-detail',
      query: { ...item },
    })
  }
  //充值
  goPay(){
    switch( this.subject_id){
      case '13001' :
        this.props.history.push(`/payment/bed`)
      break;
      case '13004' :
        this.props.history.push(`/payment/cold-water`)
      break;
      case '13005' :
        this.props.history.push(`/payment/hot-water`)
      break;
    }
  }

  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this

    const row = (rowData: any, sectionID: any, rowID: any) => {
      return (
        <div
          key={rowID}
          onClick={() => {
            this.navDetail(rowData)
          }}
        >
          <Item arrow="horizontal">
            <div className="com-item">
              <div className="com-time font-4">
                {rowData.week} <div>{rowData.time}</div>
              </div>
              <div className="imgbag" >
                <img
                  src={`/public/assets/img/${
                    this.itemKeyValue[this.subject_id].img
                  }`}
                  alt="ax.png"
                />
              </div>
              <div className="font-7">
                <div className="com-money font-4">{rowData.real_money} </div>
                {rowData.remark}
              </div>
            </div>
          </Item>
        </div>
      )
    }

    return (
      <ListView
        className="complex-list"
        ref={(el: any) => (this.lv = el)}
        dataSource={this.state.dataSource}
        renderFooter={() => (
          <Footer isLoading={isLoading} isHasMore={isHasMore} dataSource={this.state.dataSource}/>
        )}
        renderSectionHeader={sectionData => <div>{sectionData}</div>}
        renderBodyComponent={() => <MyBody info={this.props.location.state} goPay={this.goPay} dataSource={this.state.dataSource} />}
        renderRow={row}
        style={{
          height: this.state.height,
          overflow: 'auto',
        }}
        onEndReached={this.onEndReached}
        pullToRefresh={
          <APullToRefresh
            refreshing={isRefreshing}
            onRefresh={this.onRefresh}
          />
        }
      />
    )
  }
}

export default ComplexList
